import Text from '../Base/Text/Text';
import styles from './PatientTimeZoneInfo.module.scss';
import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment-timezone';
import apiClient from '../../Services/ApiClient';
import { PATIENT_TIMEZONE } from '../../Modules/Patient/Graphql/patientTimezone.graphql';
import { Moment } from 'moment';

interface PatientTimeZoneInfoProps {
	patientId: string;
	doctorId?: string;
	time: Moment | null;
	onChange?: (values: PatientTimeZoneInfoValues) => void;
}

export interface PatientTimeZoneInfoValues {
	timeDiff: string;
	patientTimezone: string;
}

const PatientTimeZoneInfo = (props: PatientTimeZoneInfoProps) => {
	const { patientId, time: inputTime, onChange } = props;
	const loggedUserTimezone = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;
	const [patientTimezone, setPatientTimezone] = useState(null);
	const [time, setTime] = useState(null);
	const [showTime, setShowTime] = useState(true);

	useEffect(() => {
		if (!patientId) {
			return;
		}

		const a = async () => {
			const { meta, data } = await apiClient.graphql({
				query: PATIENT_TIMEZONE,
				variables: {
					userId: patientId,
				},
			});

			setPatientTimezone(data?.user?.profile?.timezone);
		};

		a();
	}, [patientId]);

	useEffect(() => {
		if (!patientTimezone) {
			return;
		}

		handleGetPatientsTimes();
		getUsersTimezonesDiff();
	}, [patientTimezone, inputTime]);

	// @ts-ignore
	const handleGetPatientsTimes = () => {
		if (!inputTime) {
			return;
		}

		if (patientTimezone) {
			setTime(moment(inputTime).tz(patientTimezone).format('HH:mm'));

			onChange &&
				onChange({
					timeDiff: getUsersTimezonesDiff(),
					patientTimezone,
				});
		}
	};

	const getUsersTimezonesDiff = () => {
		if (patientTimezone && loggedUserTimezone) {
			let diffInMinutes = Math.abs(
				moment().tz(patientTimezone).utcOffset() -
					moment().tz(loggedUserTimezone).utcOffset(),
			);

			if (diffInMinutes <= 0) {
				setShowTime(false);
				return '';
			} else {
				setShowTime(true);
			}

			return `${loggedUserTimezone > patientTimezone ? '-' : '+'} ${
				diffInMinutes / 60
			}`;
		}

		return '';
	};

	if (patientTimezone === loggedUserTimezone || !time || !showTime) {
		return <></>;
	}

	return (
		<div className={styles.container}>
			<Text tx={'base.patientsTime'} inline={true} firstUpper={true} />: {time}
		</div>
	);
};

export default PatientTimeZoneInfo;
